// import React from 'react';
// import { 
//   Award, ShieldAlert, Copyright, Fingerprint, 
//   ChevronLeft, Scale, ShieldCheck, FileSignature, 
//   HelpCircle, Lightbulb 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function IntellectualPropertyServices() {
  
//   // Core IP and Trademark protection offerings
//   const ipServices = [
//     {
//       title: "تسجيل وحماية العلامات التجارية",
//       desc: "إجراء عمليات البحث عن مدى توافر العلامة، ومتابعة خطوات التسجيل وإصدار الشهادات محلياً ودولياً عبر بروتوكول مدريد، والتصدّي لحالات التشابه والتقليد.",
//       icon: <Fingerprint className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "براءات الاختراع والنماذج الصناعية",
//       desc: "صياغة وتجهيز طلبات براءات الاختراع وإيداعها لدى الهيئة السعودية للملكية الفكرية، وحماية الابتكارات التقنية والهندسية من الاستنساخ.",
//       icon: <Lightbulb className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "حقوق المؤلف والمصنفات الرقمية",
//       desc: "توثيق حقوق التأليف والنشر للمصنفات الأدبية والفنية، وحماية البرمجيات، التطبيقات الذكية، وقواعد البيانات الرقمية، وصياغة اتفاقيات الاستخدام.",
//       icon: <Copyright className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "دعاوى الانتهاك والتعويض القضائي",
//       desc: "التمثيل القضائي في منازعات الملكية الفكرية، ورفع دعاوى شطب العلامات التجارية المماثلة، وملاحقة قضايا غش المستهلك والتعويض عن التزوير.",
//       icon: <Scale className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-slate-50 text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات الملكية الفكرية وحماية العلامات التجارية"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">تأمين الأصول غير الملموسة وبناء القيمة التنافسية</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات الملكية الفكرية وحماية العلامات التجارية</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             هويتك التجارية وابتكاراتك هي أثمن ما تملك منشأتك. نحن نوفر الحماية القانونية المطلقة لأصولك الفكرية عبر تسجيلها، وصياغة عقود استغلالها، والدفاع عنها بشراسة أمام الجهات القضائية.
//           </p>
//         </div>
//       </section>

//       {/* Strategic / Asset Shielding Framework */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col lg:flex-row gap-12 items-center">
//           <div className="flex-1">
//             <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-6 leading-tight">
//               حماية أصولك المعرفية هي صمام الأمان لتوسعك الاستثماري
//             </h2>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
//               في ظل الانفتاح الاقتصادي والتنافسية الرقمية العالية، أصبح إهمال تسجيل العلامة التجارية أو براءة الاختراع ثغرة خطيرة قد تستغلها الكيانات المنافسة للاستحواذ على عملائك أو تقييد حريتك في استخدام ابتكارك الخاص.
//             </p>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed">
//               يمتلك مستشارونا المتخصصون خبرة ممتدة في التعامل مع الأنظمة والاتفاقيات الدولية للملكية الفكرية. نحن لا نكتفي بمجرد إيداع الطلبات، بل نصمم للشركات استراتيجيات وقائية متكاملة تشمل صياغة بنود السرية الصارمة (NDA)، وحوكمة تراخيص الاستخدام، وحماية الأسرار التجارية التي تمنح منشأتك تفوقاً مستداماً في السوق.
//             </p>
//           </div>
          
//           {/* Quick Framework Checklist Box */}
//           <div className="w-full lg:w-80 bg-slate-900 text-white p-6 rounded-xl border border-slate-800 space-y-4 shadow-lg">
//             <h3 className="font-bold text-amber-500 text-base flex items-center gap-2">
//               <ShieldCheck className="w-5 h-5" /> منافع التسجيل والإنفاذ:
//             </h3>
//             <ul className="space-y-3 text-xs text-slate-300">
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>منع المنافسين من استخدام أسماء أو شعارات مضللة.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>إمكانية بيع أو تأجير العلامة وتوسيع نطاق الامتياز التجاري.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>رفع القيمة الدفترية والمالية للشركة أمام المستثمرين.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>الحق في مصادرة البضائع المقلدة ومطالبة المزورين بالتعويض.</span>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Grid: Scope of Services */}
//       <section className="max-w-6xl mx-auto py-12 px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">منظومة الحماية والإنفاذ الفكري</h2>
//           <p className="text-gray-500">حلول متكاملة تغطي كافة جوانب الابتكار، والتصاميم الصناعية، والهويات التجارية</p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {ipServices.map((service, index) => (
//             <div key={index} className="bg-white p-8 rounded-xl border border-gray-100 hover:border-amber-500 hover:shadow-md transition-all duration-300">
//               <div className="p-3 bg-slate-50 rounded-lg w-fit text-slate-700 mb-4">
//                 {service.icon}
//               </div>
//               <h3 className="text-xl font-bold text-slate-800 mb-2">{service.title}</h3>
//               <p className="text-gray-500 text-sm leading-relaxed">{service.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Regulatory Context Disclaimer / Tip */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <HelpCircle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">تنبيه هام بشأن أسبقية تسجيل العلامة:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               يعتمد النظام السعودي للملكية الفكرية بشكل أساسي مبدأ "الأسبقية في التسجيل" وليس الأسبقية في الاستخدام الفعلي داخل السوق. بالتالي، فإن تأخرك في تسجيل هويتك أو اسم مشروعك يمنح الغير فرصة قيدها نظاماً باسمه، مما قد يضطرك لخوض منازعات قضائية معقدة ومكلفة لإثبات عدم قانونية التسجيل الكيدي.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Action Banner for Lead Generation */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <FileSignature className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل ترغب في تسجيل علامتك أو حماية ابتكارك؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           تواصل مع فريقنا المتخصص اليوم لإجراء فحص مبدئي لعلامتك التجارية والتحقق من سلامتها الإجرائية قبل البدء في خطوات التسجيل الرسمي لمنع الهدر المالي.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           طلب فحص وتسجيل أصل فكري
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }

import React from 'react';
import { 
  Award, ShieldAlert, Copyright, Fingerprint, 
  ChevronLeft, Scale, ShieldCheck, FileSignature, 
  HelpCircle, Lightbulb 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';

export default function IntellectualPropertyServices() {
  
  // Core IP and Trademark protection offerings - Refactored to Navy Light
  const ipServices = [
    {
      title: "تسجيل وحماية العلامات التجارية",
      desc: "إجراء عمليات البحث عن مدى توافر العلامة، ومتابعة خطوات التسجيل وإصدار الشهادات محلياً ودولياً عبر بروتوكول مدريد، والتصدّي لحالات التشابه والتقليد.",
      icon: <Fingerprint className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "براءات الاختراع والنماذج الصناعية",
      desc: "صياغة وتجهيز طلبات براءات الاختراع وإيداعها لدى الهيئة السعودية للملكية الفكرية، وحماية الابتكارات التقنية والهندسية من الاستنساخ.",
      icon: <Lightbulb className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "حقوق المؤلف والمصنفات الرقمية",
      desc: "توثيق حقوق التأليف والنشر للمصنفات الأدبية والفنية، وحماية البرمجيات، التطبيقات الذكية، وقواعد البيانات الرقمية، وصياغة اتفاقيات الاستخدام.",
      icon: <Copyright className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "دعاوى الانتهاك والتعويض القضائي",
      desc: "التمثيل القضائي في منازعات الملكية الفكرية، ورفع دعاوى شطب العلامات التجارية المماثلة، وملاحقة قضايا غش المستهلك والتعويض عن التزوير.",
      icon: <Scale className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات الملكية الفكرية وحماية العلامات التجارية"
        description="نهيئ لأصولكم المعرفية وهويتكم التجارية الحماية المطلقة والامتثال الكامل للأنظمة المحلية والدولية"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('[https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80](https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80)'        )] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">تأمين الأصول غير الملموسة وبناء القيمة التنافسية</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات الملكية الفكرية وحماية العلامات التجارية</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            هويتك التجارية وابتكاراتك هي أثمن ما تملك منشأتك. نحن نوفر الحماية القانونية المطلقة لأصولك الفكرية عبر تسجيلها، وصياغة عقود استغلالها، والدفاع عنها بشراسة أمام الجهات القضائية.
          </p>
        </div>
      </section>

      {/* Strategic / Asset Shielding Framework */}
      {/* Intellectual Property Protection - Optimized Responsive Desktop Layout */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200/60 flex flex-col lg:flex-row gap-8 lg:gap-12 items-center lg:items-stretch">
          
          {/* Main Text Content */}
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              حماية أصولك المعرفية هي صمام الأمان لتوسعك الاستثماري
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              في ظل الانفتاح الاقتصادي والتنافسية الرقمية العالية، أصبح إهمال تسجيل العلامة التجارية أو براءة الاختراع ثغرة خطيرة قد تستغلها الكيانات المنافسة للاستحواذ على عملائك أو تقييد حريتك في استخدام ابتكارك الخاص.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              يمتلك مستشارونا المتخصصون خبرة ممتدة في التعامل مع الأنظمة والاتفاقيات الدولية للملكية الفكرية. نحن لا نكتفي بمجرد إيداع الطلبات، بل نصمم للشركات استراتيجيات وقائية متكاملة تشمل صياغة بنود السرية الصارمة (NDA)، وحوكمة تراخيص الاستخدام، وحماية الأسرار التجارية التي تمنح منشأتك تفوقاً مستداماً في السوق.
            </p>
          </div>
          
          {/* Quick Framework Checklist Box - Fixed Desktop Responsiveness */}
          <div className="w-full lg:w-96 lg:max-w-md shrink-0 bg-indigo-950 text-white p-8 rounded-xl border border-indigo-900/50 space-y-5 shadow-md flex flex-col justify-center">
            <h3 className="font-bold text-white text-base flex items-center gap-2 border-b border-white/10 pb-3">
              <ShieldCheck className="w-5 h-5 text-blue-400" /> منافع التسجيل والإنفاذ:
            </h3>
            <ul className="space-y-4 text-xs md:text-sm text-slate-200 font-light">
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>منع المنافسين من استخدام أسماء أو شعارات مضللة.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>إمكانية بيع أو تأجير العلامة وتوسيع نطاق الامتياز التجاري.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>رفع القيمة الدفترية والمالية للشركة أمام المستثمرين.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>الحق في مصادرة البضائع المقلدة ومطالبة المزورين بالتعويض.</span>
              </li>
            </ul>
          </div>

        </div>
      </section>
      {/* Grid: Scope of Services - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">منظومة الحماية والإنفاذ الفكري</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">حلول متكاملة تغطي كافة جوانب الابتكار، والتصاميم الصناعية، والهويات التجارية</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {ipServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Regulatory Context Disclaimer / Tip - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <HelpCircle className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">تنبيه هام بشأن أسبقية تسجيل العلامة:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              يعتمد النظام السعودي للملكية الفكرية بشكل أساسي مبدأ "الأسبقية في التسجيل" وليس الأسبقية في الاستخدام الفعلي داخل السوق. بالتالي، فإن تأخرك في تسجيل هويتك أو اسم مشروعك يمنح الغير فرصة قيدها نظاماً باسمه، مما قد يضطرك لخوض منازعات قضائية معقدة ومكلفة لإثبات عدم قانونية التسجيل الكيدي.
            </p>
          </div>
        </div>
      </section>

      {/* Action Banner for Lead Generation - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <FileSignature className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">هل ترغب في تسجيل علامتك أو حماية ابتكارك?</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          تواصل مع فريقنا المتخصص اليوم لإجراء فحص مبدئي لعلامتك التجارية والتحقق من سلامتها الإجرائية قبل البدء في خطوات التسجيل الرسمي لمنع الهدر المالي.
        </p>
        <button className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm inline-flex items-center gap-2">
          طلب فحص وتسجيل أصل فكري
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}